export const companiesDocumentsTranslations = {
  button: 'Upload document',
  empty: 'This company has no documents yet',
  create: {
    title: 'Upload Company Document',
    success: 'Document Uploaded',
    failure: 'Error uploading document: %{error}',
    label: 'Upload Document',
  },
  title: 'Documents',
  sections: {
    details: 'Document Details',
  },
  fields: {
    id: 'Document ID',
    company_id: 'Company ID',
    document_name: 'Document Name',
    document_url: 'Url',
    created_at: 'Created At',
    updated_at: 'Updated At',
    is_archived: 'Archived',
    document_comment: 'Notes',
    source: 'Source',
  },
};
